import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Chart from "react-google-charts";
import * as httpClient from "../../../util/httpClient";
import { ApplicationState } from "../../../store";
import * as CreditActions from "../../../store/credit/actions";
import { useBureauPermission, fetchCreditData } from "../../../util/credit";
import moment from "moment-timezone";
import { NavLink } from "react-router-dom";
import { getScoreRating, getScoreStatus } from "../../../util/credit";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import { useAreServicesActive } from "../../../util/CommonServices";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { content } from "./contentCredit";
import { isIdfUser } from "../../../store/service";

interface IProps {
    isIDFUser: boolean;
    source: string;
    showWYNTK?: boolean;
}

const CreditScoreTracker: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    let vintageScoreData: any[] = [];
    const bureauPermission = useBureauPermission();
    // Start Active service base UI Display Logic
    const scoreOnlyIds = [
        idfServiceIds.creditScoreMonitoring,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
    ];
    const hasCreditScoreOnlyService = useAreServicesActive(scoreOnlyIds);
    const prioritizedServiceCode = useSelector((state: ApplicationState) => {
        if (state.creditHistoryData.isOneTimeOnlyScore && !hasCreditScoreOnlyService) {
            return state.creditHistoryData.oneTimeScoreServiceCode;
        } else {
            return "";
        }
    });
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(false, bureauPermission, prioritizedServiceCode));

    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    const [isIdfUser, setIsIdfUser] = useState(false);
    const creditData = useSelector((state: ApplicationState) => {
        if (state.creditState.creditData && state.creditState.creditData.length > 0) {
            let scoreData = fetchCreditData(state.creditState.creditData, "score");
            return scoreData;
        } else {
            return null;
        }
    });

    const [chartData, setChartData] = useState([["Month", ""]]);
    const [tableViewDiv, setTableViewDiv] = useState(true);

    const [month, setMonth] = useState(0);
    const [point, setPoint] = useState(0);
    const [score, setScore] = useState(0);
    const [trackerDataloaded, setTrackerDataloaded] = useState(false);
    const [pointStatus, setPointStatus] = useState("");
    const [tooltipTriggerType, setTooltipTriggerType] = useState("both");
    const creditScores = useSelector((state: ApplicationState) => {
        if (state.creditState.creditData && state.creditState.creditData.length > 0) {
            let scoreData = fetchCreditData(state.creditState.creditData, "score");
             
            if (scoreData == null) {
                scoreData = fetchCreditData(state.creditState.creditData);
            }
            return scoreData;
        } else {
            return null;
        }
    });
    const creditScoreServiceList = [
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
    ];
    const isCreditScoreActive = useAreServicesActive(creditScoreServiceList);

    const canadaCreditServiceids = [
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaCreditScoreSimulator,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
        ezsServiceIds.tuCanadaCreditMonitoring,
    ];

    const isCanadaCreditActive = useAreServicesActive(canadaCreditServiceids);
    const [tooltipTrigger, setTooltiptrigger] = useState(false);

    let options = {
        title: "",
        hAxis: {
            title: "",
            titleTextStyle: {
                color: "#333",
            },
        },
        pointSize: 5,
        vAxis: {
            baselineColor: "#fff",
            gridlineColor: "#fff",
            textPosition: "none",
        },
        colors: ["#0000FF", "#0000FF"],
        height: 120,
        legend: {
            position: "none",
        },
        tooltip: {
            isHtml: true,
            // trigger: tooltipTriggerType,
            trigger: tooltipTrigger === false ? "selection" : "none",
        },
        chartArea: {
            left: 24,
            top: 0,
            bottom: 26,
            right: 24,
            width: "70%",
            height: "100%",
        },
        series: {
            0: {
                type: "AreaChart",
                areaOpacity: 0.1,
            },
            1: {
                type: "AreaChart",
                areaOpacity: 0.1,
            },
        },
    };

    const monthDiff = (d1: Date, d2: Date) => {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    };

    const renderEZSChart = () => {
        const totalV3Count = vintageScoreData != null ? vintageScoreData.length : 0;
        dataForChart = [];
        const parser = new DOMParser();
        const strToDecode = isCanadaCreditActive ? tLang("credit.creditScore.creditScoreWidget.label.creditVision") :"VantageScore® 3.0";
        const decodedString = strToDecode;
        const translateMonth = tLang("credit.creditScore.creditScoreTrackerWidget.tableScore.Month");
        dataForChart.push([translateMonth, decodedString]);
        const totalCountNeededFromV3ForChart = totalV3Count;
        if (totalCountNeededFromV3ForChart > 0) {
            // initial false data.
            if (totalCountNeededFromV3ForChart === 1) {
                dataForChart.push(["", vintageScoreData[0]["AttributeValue"]]);
                setTooltipTriggerType("none");
            } else {
                setTooltipTriggerType("both");
            }
            for (let index = 0; index < totalCountNeededFromV3ForChart; index++) {
                const v3Data = vintageScoreData[index];
                dataForChart.push([getFormattedDate(i18nService.get("Country"), v3Data["AttributeDate"]), v3Data["AttributeValue"]]);
            }
            setChartData(dataForChart);
        }
    };
    const renderIDFChart = () => {
        let vintageScoreDataFiltered = [];

        let currentYear = "";
        let currentMonth = "";
        for (let index = vintageScoreData.length - 1; index >= 0; index--) {
            const yearPart = vintageScoreData[index].attributeDate.substring(0, 4);
            const monthPart = vintageScoreData[index].attributeDate.substring(5, 7);
            if (currentYear === yearPart && currentMonth === monthPart) {
                // skip the data
            } else {
                vintageScoreDataFiltered.push(vintageScoreData[index]);
            }
            currentYear = yearPart;
            currentMonth = monthPart;
        }
        vintageScoreDataFiltered.sort(function (a: any, b: any) {
            let aScoreTime = moment(a.attributeDate, "YYYY-MM-DD").toDate().getTime();
            let bScoreTime = moment(b.attributeDate, "YYYY-MM-DD").toDate().getTime();
            return aScoreTime - bScoreTime;
        });

        dataForChart = [];
        const parser = new DOMParser();
        const strToDecode = "VantageScore &reg; 3.0";
        const decodedString = parser.parseFromString(`<!doctype html><body>${strToDecode}`, "text/html").body.textContent;
        const translateMonth = tLang("credit.creditScore.creditScoreTrackerWidget.tableScore.Month");
        dataForChart.push([translateMonth, decodedString]);
        const totalV3Count = vintageScoreDataFiltered != null ? vintageScoreDataFiltered.length : 0;
        if (totalV3Count > 0) {
            let totalCountNeededFromV3ForChart = vintageScoreDataFiltered.length;
            if (totalCountNeededFromV3ForChart > 0) {
                if (totalV3Count < totalCountNeededFromV3ForChart) {
                    totalCountNeededFromV3ForChart = totalV3Count;
                }
                // initial false data.
                if (totalCountNeededFromV3ForChart === 1) {
                    dataForChart.push(["", vintageScoreDataFiltered[0]["attributeValue"]]);
                    setTooltipTriggerType("none");
                } else {
                    setTooltipTriggerType("both");
                }

                const lastVantageScores = vintageScoreDataFiltered.slice(-totalCountNeededFromV3ForChart);

                for (let index = 0; index < totalCountNeededFromV3ForChart; index++) {
                    const v3Data = lastVantageScores[index];
                    const scoreDateStr = v3Data["attributeDate"].replace(/\//g, "-");
                    let scoreDate = getFormattedDate(i18nService.get("Country"), scoreDateStr);
                    dataForChart.push([scoreDate, v3Data["attributeValue"]]);
                }
                setChartData(dataForChart);
            }
        }
    };
    const ensureDataFetched = () => {
        if (props.isIDFUser != null && props.isIDFUser) {
            const requestBody = {
                "score-type": "VANTAGE+3",
            };
            httpClient
                .sendRequest("POST", `api/credit-monitoring/getScoreMonitoringData`, requestBody)
                .then((data) => {
                    data.sort(function (a: any, b: any) {
                        let aScoreTime = moment(a.attributeDate, "YYYY-MM-DD").toDate().getTime();
                        let bScoreTime = moment(b.attributeDate, "YYYY-MM-DD").toDate().getTime();
                        return aScoreTime - bScoreTime;
                    });
                    vintageScoreData = data?.filter((it: any) => it.trackerType === "Vantage");
                    if (vintageScoreData.length > 0) {
                        setScore(vintageScoreData[vintageScoreData.length - 1].attributeValue);
                    } else {
                        setScore(0);
                    }
                    if (data.length > 1) {
                        var lastPoint = data[data.length - 1].attributeDate.substring(0, 7) + "-01";
                        var secondLastPoint = data[data.length - 2].attributeDate.substring(0, 7) + "-01";
                        const monthDifference = Math.floor(moment(new Date(lastPoint)).diff(new Date(secondLastPoint), "months", true));

                        var getMonth = monthDifference;
                        var getPoint = parseInt(data[data.length - 1].attributeValue) - parseInt(data[data.length - 2].attributeValue);
                        setMonth(getMonth);
                        setPoint(getPoint);
                        if (getPoint > 0) {
                            setPointStatus("status-up");
                        } else if (getPoint === 0) {
                            setPointStatus("status-unchanged");
                        } else {
                            setPointStatus("status-down");
                        }
                    } else {
                        setPoint(0);
                        setMonth(0);
                        setPointStatus("status-unchanged");
                    }
                    renderIDFChart();
                    setTrackerDataloaded(true);
                })
                .catch(function (error) {
                    console.log(error);
                    setTrackerDataloaded(true);
                });
        } else if ( (props.isIDFUser != null || isTUUser) && creditData !== undefined ){
            setTrackerDataloaded(false);
            httpClient
                .sendRequest("GET", `api/credit-monitoring/GetCreditScoreTracker`)
                .then((data) => {
                    if (data != null && data.creditScoreHistory != null) {
                        data.creditScoreHistory.sort(function (a: any, b: any) {
                            let aScoreTime = moment(a.scoreDate, "MM/DD/YYYY").toDate().getTime();
                            let bScoreTime = moment(b.scoreDate, "MM/DD/YYYY").toDate().getTime();
                            return aScoreTime - bScoreTime;
                        });
                    }

                    if (data.creditScoreHistory.length > 0) {
                        setScore(data.creditScoreHistory[data.creditScoreHistory.length - 1].score);
                    } else {
                        setScore(0);
                    }

                    data.creditScoreHistory.forEach((value: any) => {
                        value.scoreDate = moment(value.scoreDate, "MM/DD/YYYY").toDate().toISOString();
                        vintageScoreData.push({
                            AttributeValue: parseInt(value.score),
                            AttributeDate: value.scoreDate,
                        });
                    });
                    if (data.creditScoreHistory.length > 1) {
                        let lastPoint = moment(data.creditScoreHistory[data.creditScoreHistory.length - 1].scoreDate).toDate();
                        let secondLastPoint = moment(data.creditScoreHistory[data.creditScoreHistory.length - 2].scoreDate).toDate();

                        var getMonth = Math.floor(monthDiff(secondLastPoint, lastPoint));
                        var getPoint =
                            parseInt(data.creditScoreHistory[data.creditScoreHistory.length - 1].score) -
                            parseInt(data.creditScoreHistory[data.creditScoreHistory.length - 2].score);
                        setMonth(getMonth);
                        setPoint(getPoint);
                        if (getPoint > 0) {
                            setPointStatus("status-up");
                        } else if (getPoint === 0) {
                            setPointStatus("status-unchanged");
                        } else {
                            setPointStatus("status-down");
                        }
                    } else {
                        setPoint(0);
                        setMonth(0);
                        setPointStatus("status-unchanged");
                    }
                    renderEZSChart();
                    setTrackerDataloaded(true);
                })
                .catch(function (error) {
                    console.log(error);
                    setTrackerDataloaded(true);
                });
        }
    };

    useEffect(ensureDataFetched, [props.isIDFUser, creditData]);

    useEffect(() => {
        requestCreditData();
    }, []);

    let dataForChart: any = null;

    return (
        <React.Fragment>
            <div className={props.source === "dashboard" ? "box" : ""}>
                <React.Fragment>
                    {props.source === "dashboard" && (
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions credit-score-top-content">
                                    <h2 className="box-title" id="credit-score-trend-title">
                                        {tLang("credit.creditScore.creditScoreTrackerWidget.title")}
                                    </h2>
                                    <div>
                                        <div className="box-actions">
                                            <NavLink
                                                to="/credit/score"
                                                className="default_link"
                                                onClick={() => window.addToDataLayer({ event: "Nav Credit" })}
                                            >
                                                <span className="nav-text" role="link" aria-label="find-out-more">
                                                    {tLang("credit.creditScore.creditScoreTrackerWidget.label.findMore")}
                                                </span>
                                            </NavLink>
                                        </div>
                                        {tableViewDiv === true ? (
                                            <div onClick={() => setTableViewDiv(false)} className="box-actions credit-score-top">
                                                <NavLink to="#" className="default_link">
                                                    <span className="nav-text" role="link" aria-label="View-score-in-a-table">
                                                        {tLang("credit.creditScore.creditScoreTrackerWidget.label.tableScoreView")}
                                                    </span>
                                                </NavLink>
                                            </div>
                                        ) : (
                                            <div onClick={() => setTableViewDiv(true)} className="box-actions credit-score-top">
                                                <NavLink to="#" className="default_link">
                                                        <span className="nav-text" role="link" aria-label="View-score-in-a-chart">
                                                        {tLang("credit.creditScore.creditScoreTrackerWidget.label.cartScoreView")}
                                                    </span>
                                                </NavLink>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={props.source === "credit" ? "box offset-padding" : ""}>
                        {props.source === "credit" && (
                            <div className="box-header">
                                <div className="box-title-container credit-container">
                                    <div className="box-title-icon">
                                        <RenderIcons iconName="chart-line" />
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title" id="credit-score-trend-title">
                                            {tLang("credit.creditScore.creditScoreTrackerWidget.title")}
                                        </h2>

                                        {tableViewDiv === true ? (
                                            <div onClick={() => setTableViewDiv(false)} className="box-actions">
                                                <NavLink to="#" className="default_link">
                                                    <span className="nav-text" role="link" aria-label="View-score-in-a-table">
                                                        {tLang("credit.creditScore.creditScoreTrackerWidget.label.tableScoreView")}
                                                    </span>
                                                </NavLink>
                                            </div>
                                        ) : (
                                            <div onClick={() => setTableViewDiv(true)} className="box-actions">
                                                <NavLink to="#" className="default_link">
                                                        <span className="nav-text" role="link" aria-label="View-score-in-a-chart">
                                                        {tLang("credit.creditScore.creditScoreTrackerWidget.label.cartScoreView")}
                                                    </span>
                                                </NavLink>
                                            </div>
                                        )}
                                    {
                                        props.showWYNTK && (
                                            <div style={{"marginTop": "20px"}}>
                                                <div className="box-description">
                                                        <p dangerouslySetInnerHTML={{ __html: tLang(content.whatYouNeedToKnowDescription) }} ></p>
                                                </div>
                                            </div>
                                    )}
                                        
                                    </div>
                                </div>
                                <div className="box-description"></div>
                                <div className="box-actions"></div>
                            </div>
                        )}

                        <div className="box-content" style={{ marginTop: '20px' }}>
                            {chartData && chartData.length > 1 && trackerDataloaded && (
                                <div className="m-credit-score-trend-container">
                                    <div className={"credit-score-trend " + getScoreStatus(score)}>
                                        <h2 aria-labelledby="credit-score-trend-title">
                                            <div className="credit-score-trend-value">
                                                {score}
                                            </div>
                                        </h2>
                                        <div className={"credit-score-trend-change " + pointStatus}>
                                            {point >= 0 ? "+" : ""}
                                            {point} points in <abbr title={month + " Months"}>{month}M</abbr>
                                        </div>
                                        <div className="credit-score-trend-rating">{getScoreRating(score, tLang)}</div>
                                    </div>
                                    <div id="credit-chart" className="credit-score-trend-chart">
                                        {tableViewDiv === false ? (
                                            <table className="svg-table">
                                                <tbody>
                                                    {chartData.map(
                                                        (index, key) =>
                                                        ({ index }.index[0].length > 0 && (
                                                            (key === 0) ? <tr key={key}>
                                                                <th className="google-visualization-table-tr-head" style={{ textAlign: 'left' }}>{index[0]}</th>
                                                                <th style={{ textAlign: 'left' }}>{index[1]}</th>
                                                            </tr> : <tr key={key}>
                                                                <td className="google-visualization-table-tr-head">{index[0]}</td>
                                                                <td>{index[1]}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <Chart
                                                chartType="AreaChart"
                                                loader={<div>Loading Chart</div>}
                                                data={chartData}
                                                legendToggle
                                                options={options}
                                                rootProps={{ "data-testid": "2" }}
                                                chartEvents={[
                                                    {
                                                        eventName: "ready",
                                                        callback: ({ chartWrapper, google }) => {
                                                            var chart = new google.visualization.AreaChart(document.getElementById("credit-chart"));
                                                            var svg = chart.getContainer().getElementsByTagName("svg");
                                                            setTimeout(() => {
                                                                if (chart) {
                                                                    if (chart.getContainer()) {
                                                                        var divAriaLabel = chart.getContainer().querySelectorAll("div[aria-label]");
                                                                        if (divAriaLabel.length > 0) {
                                                                            divAriaLabel.forEach(function (div: HTMLDivElement) {
                                                                                div.removeAttribute("aria-label");
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                            }, 500)
                                                           
                                                            if (svg.length > 0) {
                                                                svg[0].setAttribute("aria-label", "Credit Activity Bar Graph");
                                                                svg[0].setAttribute("role", "img");
                                                            }
                                                            document.addEventListener("keydown", (event) => {
                                                                if (event.key === "Escape") {
                                                                    setTooltiptrigger(true);
                                                                    event.stopPropagation();
                                                                    setTooltiptrigger(false);
                                                                }
                                                            });
                                                            const datachart = document.getElementsByClassName("google-visualization-tooltip");                                                                                                                                              
                                                            document.addEventListener("mousedown", (event) => {
                                                                if (datachart.length !== 0) {
                                                                    if (event instanceof MouseEvent) {
                                                                        setTooltiptrigger(true);
                                                                        setTooltiptrigger(false);
                                                                    }
                                                                }
                                                            });
                                                        },
                                                    },
                                                ]}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}
                           {creditScores && creditScores.IsIDFUser && creditScores.IsScoreExpired && trackerDataloaded && <p>To view your latest Credit Score Tracker you need to refresh your score.</p>}
                        

 
                            {!trackerDataloaded && <div className="box loading"></div>}                      
                         

                            {!isCreditScoreActive && chartData && chartData.length < 2 && (
                                <p>{tLang("credit.creditScore.creditScoreTrackerWidget.label.notAvailable")}</p>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </React.Fragment>
    );
};

export default CreditScoreTracker;
